var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
// we perform quite a few array.find, map.get checks here where we know for sure we'll get something back
/* eslint-disable @typescript-eslint/no-non-null-assertion */

// to trigger a re-render on a Map, we need to assign it to itself
/* eslint-disable no-self-assign */

import Service, { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { START_TIME_DEFAULT_VALUE, END_TIME_DEFAULT_VALUE } from '@square/dashboard-items-data/models/connect/availability-period/data';
import { areAvailabilityPeriodsIdentical, areAvailabilityPeriodsOverlapping, availabilityPeriodComparator, getLocalizedDaysOfWeek, WrappedAvailabilityPeriod } from '@dashboard/shared-ui/utils/availability/availability-period-utils';
export let AvailabilityModeEnum = /*#__PURE__*/function (AvailabilityModeEnum) {
  AvailabilityModeEnum["ALL_HOURS"] = "ALL_HOURS";
  AvailabilityModeEnum["CERTAIN_HOURS"] = "CERTAIN_HOURS";
  return AvailabilityModeEnum;
}({});
let AvailabilityPeriodsManager = (_class = class AvailabilityPeriodsManager extends Service {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "availabilityModeEnum", AvailabilityModeEnum);
    _defineProperty(this, "minimumDurationMinutes", void 0);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "store", _descriptor2, this);
    _defineProperty(this, "initialSortedAvailabilityPeriods", []);
    _initializerDefineProperty(this, "wrappedAvailabilityPeriodsByDay", _descriptor3, this);
    _initializerDefineProperty(this, "initialAvailabilityMode", _descriptor4, this);
    _initializerDefineProperty(this, "availabilityMode", _descriptor5, this);
    _defineProperty(this, "createRawAvailabilityPeriod", (dayOfWeek, startLocalTime, endLocalTime) => {
      const availabilityPeriodData = this.store.createFragment('connect/availability-period/data', {
        dayOfWeek,
        startLocalTime: startLocalTime ?? START_TIME_DEFAULT_VALUE,
        endLocalTime: endLocalTime ?? END_TIME_DEFAULT_VALUE
      });
      const availabilityPeriod = this.store.createRecord('connect/availability-period', {
        availabilityPeriodData
      });
      return availabilityPeriod;
    });
    _defineProperty(this, "createAvailabilityPeriod", (dayOfWeek, startLocalTime, endLocalTime) => {
      return new WrappedAvailabilityPeriod({
        availabilityPeriodModel: this.createRawAvailabilityPeriod(dayOfWeek, startLocalTime, endLocalTime),
        daysOfWeek: this.daysOfWeek,
        minimumDurationMinutes: this.minimumDurationMinutes
      });
    });
    _defineProperty(this, "groupAvailabilityPeriods", availabilityPeriods => {
      const groupedAvailabilityPeriods = new Map();
      for (const day of this.daysOfWeek) {
        groupedAvailabilityPeriods.set(day, []);
      }
      for (const availabilityPeriod of availabilityPeriods) {
        const dayOfWeek = availabilityPeriod.availabilityPeriodModel.dayOfWeek;
        const availabilityPeriodsForDay = groupedAvailabilityPeriods.get(dayOfWeek);
        availabilityPeriodsForDay?.push(availabilityPeriod);
      }
      return groupedAvailabilityPeriods;
    });
    _defineProperty(this, "createDefaultRawAvailabilityPeriodForDays", (startLocalTime, endLocalTime) => {
      // TODO potentially pull this info from business hour endpoints
      return this.daysOfWeek.map(dayOfWeek => this.createRawAvailabilityPeriod(dayOfWeek, startLocalTime, endLocalTime));
    });
    // this is called when a seller toggles to CERTAIN_HOURS for the first time.
    _defineProperty(this, "createDefaultAvailabilityPeriodForDays", () => {
      // TODO potentially pull this info from business hour endpoints
      return this.daysOfWeek.map(dayOfWeek => this.createAvailabilityPeriod(dayOfWeek));
    });
    /**
     * Validates all wrapped availability periods and sets the
     * isStartValid and isEndValid keys of wrapped availability periods to true if any availability
     * period is overlapping with another availability period
     */
    _defineProperty(this, "validateWrappedAvailabilityPeriods", wrappedAvailabilityPeriods => {
      this.clearAllValidationErrors(wrappedAvailabilityPeriods);
      if (wrappedAvailabilityPeriods.length === 0) {
        return;
      }
      if (wrappedAvailabilityPeriods.length === 1) {
        if (wrappedAvailabilityPeriods[0].isPeriodLessThanMinimumDuration) {
          // eslint-disable-next-line no-param-reassign
          wrappedAvailabilityPeriods[0].isEndValid = false;
        }
        return;
      }
      const sortedWrappedAvailabilityPeriods = [...wrappedAvailabilityPeriods].sort((wrappedAvailabilityPeriodA, wrappedAvailabilityPeriodB) => {
        return availabilityPeriodComparator(wrappedAvailabilityPeriodA.availabilityPeriodModel, wrappedAvailabilityPeriodB.availabilityPeriodModel, this.daysOfWeek);
      });
      for (let i = 0; i < sortedWrappedAvailabilityPeriods.length - 1; i++) {
        const wrappedAvailabilityPeriodA = sortedWrappedAvailabilityPeriods[i];
        const wrappedAvailabilityPeriodB = sortedWrappedAvailabilityPeriods[i + 1];
        if (areAvailabilityPeriodsIdentical(wrappedAvailabilityPeriodA, wrappedAvailabilityPeriodB)) {
          wrappedAvailabilityPeriodA.isStartValid = false;
          wrappedAvailabilityPeriodA.isEndValid = false;
          wrappedAvailabilityPeriodB.isStartValid = false;
          wrappedAvailabilityPeriodB.isEndValid = false;
        } else if (areAvailabilityPeriodsOverlapping(wrappedAvailabilityPeriodA, wrappedAvailabilityPeriodB)) {
          wrappedAvailabilityPeriodA.isEndValid = false;
          wrappedAvailabilityPeriodB.isStartValid = false;
        } else if (wrappedAvailabilityPeriodA.isPeriodLessThanMinimumDuration) {
          wrappedAvailabilityPeriodA.isEndValid = false;
        }
      }

      // perform a wrap around validation (ie. is the last availability period overlapping with the first one)
      const lastAvailabilityPeriod = sortedWrappedAvailabilityPeriods[sortedWrappedAvailabilityPeriods.length - 1];
      const firstAvailabilityPeriod = sortedWrappedAvailabilityPeriods[0];
      if (lastAvailabilityPeriod.isLastDayOfWeek && firstAvailabilityPeriod.isFirstDayOfWeek && areAvailabilityPeriodsOverlapping(lastAvailabilityPeriod, firstAvailabilityPeriod)) {
        lastAvailabilityPeriod.isEndValid = false;
        firstAvailabilityPeriod.isStartValid = false;
      }
    });
    _defineProperty(this, "clearAllValidationErrors", wrappedAvailabilityPeriods => {
      for (const wrappedAvailabilityPeriod of wrappedAvailabilityPeriods) {
        wrappedAvailabilityPeriod.clearErrors();
      }
    });
  }
  initialize(availabilityPeriods = [], minimumDurationMinutes) {
    this.minimumDurationMinutes = minimumDurationMinutes;
    const sortedAvailabilityPeriods = [...availabilityPeriods.sort((a, b) => {
      return availabilityPeriodComparator(a, b, this.daysOfWeek);
    })];

    // we are using getProperties to create a copy of the original availability periods. This will ensure that
    // when availability periods are modified, the initialSortedAvailabilityPeriods are not modified
    this.initialSortedAvailabilityPeriods = sortedAvailabilityPeriods.map(ap => ap.getProperties('dayOfWeek', 'startLocalTime', 'endLocalTime'));
    const wrappedAvailabilityPeriods = sortedAvailabilityPeriods.map(availabilityPeriod => new WrappedAvailabilityPeriod({
      availabilityPeriodModel: availabilityPeriod,
      daysOfWeek: this.daysOfWeek,
      minimumDurationMinutes: this.minimumDurationMinutes
    }));
    const wrappedAvailabilityPeriodsByDay = this.groupAvailabilityPeriods(wrappedAvailabilityPeriods);
    this.wrappedAvailabilityPeriodsByDay = wrappedAvailabilityPeriodsByDay;
    if (availabilityPeriods.length > 0) {
      this.availabilityMode = AvailabilityModeEnum.CERTAIN_HOURS;
      this.initialAvailabilityMode = AvailabilityModeEnum.CERTAIN_HOURS;
    } else {
      this.availabilityMode = AvailabilityModeEnum.ALL_HOURS;
      this.initialAvailabilityMode = AvailabilityModeEnum.ALL_HOURS;
    }
    this.validateWrappedAvailabilityPeriods(this.wrappedAvailabilityPeriods);
  }
  updateAvailabilityMode(newAvailabilityMode) {
    this.availabilityMode = newAvailabilityMode;
    if (this.availabilityMode === AvailabilityModeEnum.CERTAIN_HOURS && this.wrappedAvailabilityPeriods.length === 0) {
      const availabilityPeriods = this.createDefaultAvailabilityPeriodForDays();
      this.wrappedAvailabilityPeriodsByDay = this.groupAvailabilityPeriods(availabilityPeriods);
    }
  }
  addDefaultAvailabilityPeriod(dayOfWeek, startLocalTime, endLocalTime) {
    const newAvailabilityPeriod = this.createAvailabilityPeriod(dayOfWeek, startLocalTime, endLocalTime);
    const availabilityPeriodsForDay = this.wrappedAvailabilityPeriodsByDay.get(dayOfWeek);
    const newAvailabilityPeriodsForDay = [...availabilityPeriodsForDay, newAvailabilityPeriod];
    this.wrappedAvailabilityPeriodsByDay.set(dayOfWeek, newAvailabilityPeriodsForDay);
    this.wrappedAvailabilityPeriodsByDay = this.wrappedAvailabilityPeriodsByDay;
    this.validateWrappedAvailabilityPeriods(this.wrappedAvailabilityPeriods);
  }
  addAvailabilityPeriod(indexToAddTo, availabilityPeriod) {
    const dayOfWeek = availabilityPeriod.availabilityPeriodModel.dayOfWeek;
    const availabilityPeriodsForDay = this.wrappedAvailabilityPeriodsByDay.get(dayOfWeek);
    const newAvailabilityPeriodsForDay = [...availabilityPeriodsForDay.slice(0, indexToAddTo), availabilityPeriod, ...availabilityPeriodsForDay.slice(indexToAddTo)];
    this.wrappedAvailabilityPeriodsByDay.set(dayOfWeek, newAvailabilityPeriodsForDay);
    this.wrappedAvailabilityPeriodsByDay = this.wrappedAvailabilityPeriodsByDay;
    this.validateWrappedAvailabilityPeriods(this.wrappedAvailabilityPeriods);
  }
  deleteAvailabilityPeriod(id, dayOfWeek) {
    const availabilityPeriodsForDay = this.wrappedAvailabilityPeriodsByDay.get(dayOfWeek);
    const newAvailabilityPeriodsForDay = availabilityPeriodsForDay.filter(availabilityPeriod => availabilityPeriod.availabilityPeriodModel.idOrTempId() !== id);
    this.wrappedAvailabilityPeriodsByDay.set(dayOfWeek, newAvailabilityPeriodsForDay);
    this.wrappedAvailabilityPeriodsByDay = this.wrappedAvailabilityPeriodsByDay;
    this.validateWrappedAvailabilityPeriods(this.wrappedAvailabilityPeriods);
  }
  deleteAvailabilityPeriodsForDay(dayOfWeek) {
    this.wrappedAvailabilityPeriodsByDay.set(dayOfWeek, []);
    this.wrappedAvailabilityPeriodsByDay = this.wrappedAvailabilityPeriodsByDay;
    this.validateWrappedAvailabilityPeriods(this.wrappedAvailabilityPeriods);
  }
  handleAvailabilityPeriodChange({
    id,
    startLocalTime,
    endLocalTime,
    dayOfWeek
  }) {
    const availabilityPeriodsForDay = this.wrappedAvailabilityPeriodsByDay.get(dayOfWeek);
    const availabilityPeriod = availabilityPeriodsForDay.find(ap => ap.availabilityPeriodModel.idOrTempId() === id);
    availabilityPeriod.availabilityPeriodModel.startLocalTime = startLocalTime;
    availabilityPeriod.availabilityPeriodModel.endLocalTime = endLocalTime;
    this.wrappedAvailabilityPeriodsByDay.set(dayOfWeek, availabilityPeriodsForDay);
    this.wrappedAvailabilityPeriodsByDay = this.wrappedAvailabilityPeriodsByDay;
    this.validateAvailabilityPeriod(availabilityPeriod);
    if (!availabilityPeriod.isValid) {
      return;
    }
    this.validateWrappedAvailabilityPeriods(this.wrappedAvailabilityPeriods);
  }
  get daysOfWeek() {
    return getLocalizedDaysOfWeek(this.intl.primaryLocale);
  }
  get isModeCertainHours() {
    return this.availabilityMode === this.availabilityModeEnum.CERTAIN_HOURS;
  }
  get wrappedAvailabilityPeriods() {
    const availabilityPeriods = [];
    for (const wrappedAvailabilityPeriodsForDay of this.wrappedAvailabilityPeriodsByDay.values()) {
      availabilityPeriods.push(...wrappedAvailabilityPeriodsForDay);
    }
    return availabilityPeriods;
  }
  get hasValidationErrors() {
    return this.wrappedAvailabilityPeriods.some(ap => !ap.isValid);
  }
  get currentAvailabilityPeriods() {
    return this.wrappedAvailabilityPeriods.map(wap => wap.availabilityPeriodModel);
  }
  get isAvailabilityModeDirty() {
    return this.initialAvailabilityMode !== this.availabilityMode;
  }
  get isAvailabilityPeriodsDirty() {
    if (this.initialSortedAvailabilityPeriods.length !== this.currentAvailabilityPeriods.length) {
      return true;
    }
    const currentSortedAvailabilityPeriods = [...this.currentAvailabilityPeriods.sort((a, b) => {
      return availabilityPeriodComparator(a, b, this.daysOfWeek);
    })];
    for (let i = 0; i < this.initialSortedAvailabilityPeriods.length; i++) {
      const initialAp = this.initialSortedAvailabilityPeriods[i];
      const currentAp = currentSortedAvailabilityPeriods[i];
      if (!areAvailabilityPeriodsIdentical(initialAp, currentAp)) {
        return true;
      }
    }
    return false;
  }
  copyAvailabilityPeriodToAll(dayOfWeek) {
    const availabilityPeriodsForDay = this.wrappedAvailabilityPeriodsByDay.get(dayOfWeek);
    this.daysOfWeek.forEach(dayOfWeek => {
      const clonedAvailabilityPeriods = availabilityPeriodsForDay.map(availabilityPeriod => {
        return new WrappedAvailabilityPeriod({
          availabilityPeriodModel: this.createRawAvailabilityPeriod(dayOfWeek, availabilityPeriod.availabilityPeriodModel.startLocalTime, availabilityPeriod.availabilityPeriodModel.endLocalTime),
          daysOfWeek: this.daysOfWeek,
          minimumDurationMinutes: this.minimumDurationMinutes
        });
      });
      this.wrappedAvailabilityPeriodsByDay.set(dayOfWeek, clonedAvailabilityPeriods);
      this.wrappedAvailabilityPeriodsByDay = this.wrappedAvailabilityPeriodsByDay;
    });
  }
  /**
   * Validates a single wrapped availability period. An availability period is invalid
   * if its start time is equal to its end time
   */
  validateAvailabilityPeriod(wrappedAvailabilityPeriod) {
    // clear validation errors
    // eslint-disable-next-line no-param-reassign
    wrappedAvailabilityPeriod.isStartValid = true;
    // eslint-disable-next-line no-param-reassign
    wrappedAvailabilityPeriod.isEndValid = true;
    const {
      startLocalTime,
      endLocalTime
    } = wrappedAvailabilityPeriod.availabilityPeriodModel;
    if (startLocalTime === endLocalTime) {
      wrappedAvailabilityPeriod.clearErrors();
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "wrappedAvailabilityPeriodsByDay", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return new Map();
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "initialAvailabilityMode", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return AvailabilityModeEnum.ALL_HOURS;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "availabilityMode", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return AvailabilityModeEnum.ALL_HOURS;
  }
}), _applyDecoratedDescriptor(_class.prototype, "initialize", [action], Object.getOwnPropertyDescriptor(_class.prototype, "initialize"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateAvailabilityMode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateAvailabilityMode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addDefaultAvailabilityPeriod", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addDefaultAvailabilityPeriod"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addAvailabilityPeriod", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addAvailabilityPeriod"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deleteAvailabilityPeriod", [action], Object.getOwnPropertyDescriptor(_class.prototype, "deleteAvailabilityPeriod"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deleteAvailabilityPeriodsForDay", [action], Object.getOwnPropertyDescriptor(_class.prototype, "deleteAvailabilityPeriodsForDay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleAvailabilityPeriodChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleAvailabilityPeriodChange"), _class.prototype), _class);
export { AvailabilityPeriodsManager as default };
/* eslint-enable no-self-assign */
/* eslint-enable @typescript-eslint/no-non-null-assertion */